import { render } from "./checkbox-tree.vue?vue&type=template&id=58cdb62a&scoped=true&lang=true"
import script from "./checkbox-tree.vue?vue&type=script&lang=js"
export * from "./checkbox-tree.vue?vue&type=script&lang=js"

import "./checkbox-tree.vue?vue&type=style&index=0&id=58cdb62a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cdb62a"]])

export default __exports__